import { h } from 'preact';

import { isVideoFile } from 'utils/assets';
import { joinClasses } from 'utils/utils';

import HubPageEditor from 'components/editor/pages/hubPageEditor';
import HubNavigation from 'components/editor/hubNavigation/hubNavigation';
import SelectableSection from 'components/editor/selectableSection';
import SimpleField from 'components/editor/settings/simpleField';
import RichTextField from 'components/editor/settings/richTextField';
import MediaField from 'components/editor/settings/mediaField';
import HTML from 'components/core/html/html';

import s from 'components/editor/pages/about/about.sss';

export default class AboutEditor extends HubPageEditor {
	s = s;

	constructor(props) {
		super(props);
		this.selectRoot = this.selectRoot.bind(this);
		this.onSettingsSubsectionClick = this.onSettingsSubsectionClick.bind(this);
	}

	selectRoot() {
		this.props.select('/');
	}

	renderVisualHeader() {}

	renderVisualHero() {
		const content = this.props.content;
		const src = content?.hero?.src;
		let asset;
		if (src) {
			asset = isVideoFile(src) ? (
				<video src={src} muted autoplay loop playsinline />
			) : (
				<img src={src} alt={content.hero.alt || ''} />
			);
		}
		return (
			<SelectableSection {...this.props} section="/hero" class={joinClasses(this.s.asset, !asset && this.s.placeholder)}>
				{asset || 'Add hero...'}
			</SelectableSection>
		);
	}

	renderVisualContent() {
		const content = this.props.content?.content;
		return (
			<SelectableSection {...this.props} section="/content" class={joinClasses(this.s.content, !content && this.s.placeholder)}>
				<HTML>{content || 'Add content here...'}</HTML>
			</SelectableSection>
		);
	}

	renderVisualParts() {
		return [
			this.renderVisualHeader(),
			this.renderVisualHero(),
			this.renderVisualContent()
		];
	}

	renderVisual() {
		return (
			<div class={this.s.visual}>
				<HubNavigation />
				<SelectableSection {...this.props} section="/" class={this.s.wrapper}>
					{this.renderVisualParts()}
				</SelectableSection>
			</div>
		);
	}

	renderHeroSettings() {
		return [
			<MediaField
				{...this.props}
				anyType
				label="Banner"
				path={`${this.props.dataRoot}/content/hero/src`}
				group={this.props.config?.id}
				assetData={{ type: 'About Page Hero', aspectRatio: '16:6' }}
				key="hero-image"
			/>,
			<SimpleField label="Alt text" path={`${this.props.dataRoot}/content/hero/alt`} key="hero-alt" />
		];
	}

	renderContentSettings() {
		return <RichTextField label="Text" {...this.props} path={`${this.props.dataRoot}/content/content`} rows="24" key="content" />;
	}

	allSettingsOptions() {
		return [
			{ label: 'Hero', path: '/hero' },
			{ label: 'Content', path: '/content' },
		];
	}
	onSettingsSubsectionClick(e) {
		const path = e.currentTarget?.dataset?.path;
		if (path) this.props.select(path);
	}
	renderAllSettings() {
		const options = this.allSettingsOptions();
		return options.map(({ label, path }) => (
			<div class={s.subsection} key={path}>
				<span class={s.label}>{label}</span>
				<button class={s.edit} onClick={this.onSettingsSubsectionClick} data-path={path}>
					View
				</button>
			</div>
		));
	}

	getActiveSettings() {
		switch (this.props.activeElement) {
			case '/hero':
				return {
					nav: { label: 'Hero', path: '/hero' },
					content: this.renderHeroSettings(),
				};
			case '/content':
				return {
					nav: { label: 'Content', path: '/content' },
					content: this.renderContentSettings(),
				};
			default:
				return {
					content: this.renderAllSettings(),
				};
		}
	}

	renderSettings() {
		const settings = this.getActiveSettings();
		return (
			<div class={this.s.settings}>
				{this.renderSettingsNavigation([{ label: 'About', path: '/' }, settings?.nav].filter(Boolean))}
				<div class={this.s.settingsContent}>
					{settings?.content}
				</div>
			</div>
		);
	}
}